import SEO from '../components/SEO';
import React from 'react';
import Navigation from '../components/Navigation';
import ServicesSection from '../components/ServicesSection';
import Footer from '../components/Footer';
import FAQRichSnippet from '../components/FAQRichSnippet';

const COMPREHENSIVE_FAQS = [
  { q: "What mental health services does SDORA Wellbeing offer?", a: "SDORA Wellbeing provides individual therapy, family therapy, group therapy, medication management, psychiatric rehabilitation (PRP), case management, comprehensive assessments, and telehealth services for adults, minors, and families." },
  { q: "Do I need a referral to receive services?", a: "No referral is required for most services. You can contact us directly at (877) 772-5150 or submit an intake form online to get started. Some PRP services may require a referral from a licensed mental health professional." },
  { q: "What insurance do you accept?", a: "We accept Medicaid, Maryland HealthChoice managed care organizations (Aetna Better Health, CareFirst Community, Maryland Physicians Care, Priority Partners, UnitedHealthcare), Medicare, and most major commercial insurance plans." },
  { q: "Where is SDORA Wellbeing located?", a: "Our office is at 1700 Reisterstown Rd, Suite 109, Pikesville, MD 21208. We serve clients from Baltimore City, Baltimore County, and surrounding areas. Telehealth is available statewide in Maryland." },
  { q: "Is SDORA Wellbeing accredited?", a: "Yes. SDORA Wellbeing LLC is CARF accredited, which means we meet internationally recognized standards for quality care in behavioral health services." },
];

const ComprehensiveMentalHealthPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <SEO title="Mental Health Services" description="Comprehensive outpatient mental health services including therapy, medication management, and case management at SDORA Wellbeing in Pikesville, MD." path="/services/comprehensive-mental-health" />
      
      {/* Page Header */}
      <div className="bg-gradient-to-br from-blue-50 to-purple-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Comprehensive Mental Health Services
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl">
            Therapy, rehabilitation, medication management, and community support — delivered by licensed clinicians for adults, minors, and families.
          </p>
        </div>
      </div>

      <ServicesSection />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <FAQRichSnippet faqs={COMPREHENSIVE_FAQS} />
      </div>
      <Footer />
    </div>
  );
};

export default ComprehensiveMentalHealthPage;